export default __webpack_public_path__ + "media/zurb/img/work/work-case-study-thumbnail2-bf694674f06e1daa9a4d3d07cf94886c.png";